/**
 * 视频相关常量
 */

/**
 * Q2 Pro 模型参考生视频功能中，输入视频的最大时长限制（秒）
 * 当用户上传视频作为参考时，视频时长不能超过此值
 */
export const Q2_PRO_REFERENCE_VIDEO_MAX_DURATION = 8;

/**
 * Q2 Pro 模型参考生视频功能中，输入视频的最大文件大小限制
 */
export const Q2_PRO_REFERENCE_VIDEO_MAX_FILE_SIZE = 300 * 1024 * 1024; // 300MB

// 上传视频默认最大限制为50MB
export const MAX_VIDEO_FILE_SIZE = 50 * 1024 * 1024; // 50MB

// 上传视频默认最大时长为10分钟
export const MAX_VIDEO_DURATION_IN_SECONDS = 600;

// 上传视频默认最小时长为15秒
export const MIN_VIDEO_DURATION_IN_SECONDS = 15;
